import { render, staticRenderFns } from "./revt_center_c.vue?vue&type=template&id=78fbed30&scoped=true"
import script from "./revt_center_c.vue?vue&type=script&lang=js"
export * from "./revt_center_c.vue?vue&type=script&lang=js"
import style0 from "./revt_center_c.vue?vue&type=style&index=0&id=78fbed30&prod&lang=css"
import style1 from "./revt_center_c.vue?vue&type=style&index=1&id=78fbed30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fbed30",
  null
  
)

export default component.exports